import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePageTemplate.css";
import UserCorner from "../../components/UserCorner/UserCorner";

export interface NavigationButton {
    label: string;
    icon?: React.ReactNode;
    link?: string;
    action?: () => void;
    url?: string;
}

export interface IHomePageTemplate {
    title: string;
    items: NavigationButton[];
    itemsRow2?: NavigationButton[];
    itemsRow3?: NavigationButton[];
}

/**
 * Represents the template for the home page.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the home page.
 * @param {NavigationButton[]} props.items - The navigation buttons for the first row.
 * @param {NavigationButton[]} [props.itemsRow2] - The navigation buttons for the second row (optional).
 * @returns {JSX.Element} The rendered component.
 */
export const HomePageTemplate = ({
    title,
    items: itemsRow1,
    itemsRow2 = [],
    itemsRow3 = [],
}: IHomePageTemplate) => {
    const navigate = useNavigate();
    const itemsRows = [itemsRow1, itemsRow2, itemsRow3];

    const onSelectAction = (item: NavigationButton) => {
        if (item.action) item.action();
        else if (item.link) navigate(item.link);
        else if (item.url) window.open(item.url, "_blank");
    };

    return (
        <main className="home-page-container">
            <section id="settings-section">
                <UserCorner />
            </section>
            <h1 className="home-page-title">{title}</h1>
            {itemsRows.map((items, i) => (
                <BottomNavigation showLabels key={i}>
                    {items.map((item, j) => (
                        <BottomNavigationAction
                            key={j}
                            label={item.label}
                            icon={item.icon}
                            onClick={() => onSelectAction(item)}
                        />
                    ))}
                </BottomNavigation>
            ))}
        </main>
    );
};
